import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from '@/App';

import { E3MessageBox } from 'e3-components';

import { E3Spinner } from 'e3-components';

import { ToastContainer } from 'react-toastify';
import ErrorBoundary from './ErrorBoundary';
import E3Toast from 'e3-components/components/LoadingIndicator/E3Toast';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
    <ErrorBoundary>
        <BrowserRouter>
            <App />
        </BrowserRouter>
        <E3MessageBox />
        <E3Spinner />
        <E3Toast />
    </ErrorBoundary>
);
